import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { withNamespaces } from 'react-i18next';

const ControlComponent = ({ label, required }) => (props) => (
    <div className={`form-group form-group-default ${required ? 'required': ''}`}>
        <label>{label}</label>
        <components.Control {...props} />
    </div>
);
const IndicatorSeparator = (props) => null;
const DropdownIndicator = (props) => (
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            &#x25BE;
        </components.DropdownIndicator>
    )
);
const Option = ({ t }) => (props) => (
    <components.Option {...props}>{t(props.children)}</components.Option>
);
const GroupHeading = ({ t }) => (props) => (
    <components.GroupHeading {...props}>{t(props.children)}</components.GroupHeading>
);
const SingleValue = ({ t }) => (props) => (
    <components.SingleValue {...props}>{t(props.children)}</components.SingleValue>
);

@withNamespaces()
class SelectField extends Component {
    // 3rd party documentation: https://react-select.com/home

    constructor(props) {
        super();

        // Value stored is an object, but value from props is string, therefore we must find the object in options
        let value;
        if (props.options && props.options.length > 0 && typeof props.options[0].options !== typeof undefined) {
            // This is a deep list with groups
            const bigCategory = props.options.find(grp => grp.options.find(opt => opt.value === props.value));
            if (bigCategory) {
                value = bigCategory.options.find(opt => opt.value === props.value);
            }
        } else {
            // This is a simple list
            value = props.options.find(opt => opt.value === props.value);
        }

        this.state = {
            value,
        };

        this.handleChange = this.handleChange.bind(this);
        this.valueSelected = this.valueSelected.bind(this);
        this.findOption = this.findOption.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // If value passed to props changes, we must find the option again
        if (this.props.value !== nextProps.value) {
            this.setState({ value: this.findOption(nextProps.value) });
        }
    }

    handleChange(e, {action}) {
        switch (action) {
            case 'select-option':
                this.valueSelected(e);
                break;

            case 'clear':
                this.valueSelected(null);
                break;

            default:
        }
    }

    valueSelected(e) {
        this.setState({ value: e });

        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: e ? e.value : '',
                    object: e,
                },
            });
        }
    }

    findOption(value) {
        const { options } = this.props;

        if (options) {
            return options.find(opt => opt.value === value);
        }
    }

    render() {
        const { t, label, required, error, components, disabled } = this.props;
        const { value } = this.state;

        return (
            <Select
                styles={styles({ error })}
                {...this.props}
                components={{
                    Control: ControlComponent({label, required}),
                    Option: Option({ t }),
                    GroupHeading: GroupHeading({ t }),
                    SingleValue: SingleValue({ t }),
                    IndicatorSeparator,
                    DropdownIndicator,
                    ...components
                }}
                onChange={this.handleChange}
                value={value}
                isDisabled={disabled}
            />
        );
    }
}

const styles = ({ addonPre, addonPost, error }) => ({
    container: (stl) => ({
        ...stl,
    }),
    control: (stl, { isFocused, isDisabled }) => {
        return {
            alignItems: "center",
            boxShadow: null,
            boxSizing: "border-box",
            cursor: "default",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            //minHeight: 38,
            outline: "0 !important",
            position: "relative",
            transition: 'all 100ms',
            height: 25,
        };
    },
    menu: (stl) => ({
        ...stl,
        //position: 'fixed',
        marginTop: 0,
        //zIndex: 100,
    }),
    valueContainer: (stl) => ({
        //
    }),
});

SelectField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    options: PropTypes.array,
    onChange: PropTypes.func,
    error: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default SelectField;


// WEBPACK FOOTER //
// ./src/components/form/select-field.js